import { render, staticRenderFns } from "./UploadStudentsBatch.vue?vue&type=template&id=a34177a8&scoped=true&"
import script from "./UploadStudentsBatch.vue?vue&type=script&lang=js&"
export * from "./UploadStudentsBatch.vue?vue&type=script&lang=js&"
import style0 from "./UploadStudentsBatch.vue?vue&type=style&index=0&id=a34177a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34177a8",
  null
  
)

component.options.__file = "UploadStudentsBatch.vue"
export default component.exports